

































import Card from '@/components/Card'

export default {
    name: 'Cards'

    components:
        Card: Card

    data: -> fields: @defaultFields

    computed:
        isDark: -> @$parent.isDark
        isSlider: -> @fields.slide_function is 'eingeschaltet'
        smallCards: -> @fields.card_size is 'klein'
        imageHeight: ->
            if @fields.image_height is 'standard' then '60%' else @fields.image_height
        gridClass: ->
            'uk-child-width-1-2@s uk-child-width-1-3@m': !@smallCards
            'uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l': @smallCards

    methods:
        defaultFields: ->
            slide_function: 'ausgeschaltet'
            card_size: 'groß',
            image_height: '60%',
            cards: []

        setContent: (document) ->
            fields =
                slide_function: document.primary.slide_function
                card_size: document.primary.card_size
                image_height: document.primary.image_height
                cards: document.items
            $.extend @fields, fields
    
    created: ->
        @setContent @$attrs.document

}
